/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "@app/axios/axiosIns";

export const getAllBlogs = createAsyncThunk(
  "blog/getAll",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/admin/blog", { params });
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getBlogById = createAsyncThunk(
  "blog/getById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/blog/${id}`);
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const addBlog = createAsyncThunk(
  "blog/add",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/admin/blog", data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateBlog = createAsyncThunk(
  "blog/update",
  async ({ id, data }: { id: string; data: any }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`/admin/blog/${id}`, data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteBlog = createAsyncThunk(
  "blog/delete",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/admin/blog/${id}`);
      return response;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

interface BlogState {
  isLoading: boolean;
  formLoader: boolean;
  blogs: any;
  blog: any;
  error: any;
}

const initialState: BlogState = {
  isLoading: false,
  formLoader: false,
  blogs: [],
  blog: null,
  error: null,
};

const blogSlice: any = createSlice({
  name: "blog",
  initialState,
  reducers: {
    resetState: () => initialState,
    clearBlog: (state) => {
      state.blog = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get All
      .addCase(getAllBlogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllBlogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blogs = action.payload?.data;
      })
      .addCase(getAllBlogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // Get By ID
      .addCase(getBlogById.pending, (state) => {
        state.isLoading = true;
        state.blog = null;
      })
      .addCase(getBlogById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.blog = action.payload?.data;
      })
      .addCase(getBlogById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // Add
      .addCase(addBlog.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(addBlog.fulfilled, (state, action) => {
        state.formLoader = false;
        state.blog = action.payload?.data?.data;
      })
      .addCase(addBlog.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.error.message;
      })
      // Update
      .addCase(updateBlog.pending, (state) => {
        state.formLoader = true;
      })
      .addCase(updateBlog.fulfilled, (state, action) => {
        state.formLoader = false;
        state.blog = action.payload?.data?.data;
      })
      .addCase(updateBlog.rejected, (state, action) => {
        state.formLoader = false;
        state.error = action.error.message;
      })
      // Delete
      .addCase(deleteBlog.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteBlog.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deleteBlog.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetState, clearBlog } = blogSlice.actions;
export default blogSlice.reducer;
